import { Sparkles } from 'lucide-react'

interface ModuleUpdateBannerProps {
  moduleSlug: string
}

// List of recently updated modules (January 2026)
const UPDATED_MODULES = [
  'systematic-strategies',
  'market-microstructure',
  'high-frequency-trading',
  'execution-algorithms',
  'blockchain-technology',
  'create-cryptocurrency',
  'cryptocurrency-fundamentals',
  'defi-protocols',
  'digital-asset-trading',
  'julia-whitepaper',
  'market-risk-fundamentals',
  'liquidity-management',
  'factor-investing',
  'stochastic-calculus',
  'commodity-risk-management'
];

const UPDATE_DESCRIPTIONS: Record<string, string> = {
  'systematic-strategies': 'Expanded to 8,934 words with enhanced strategy frameworks',
  'market-microstructure': 'Expanded to 8,846 words with improved order book dynamics',
  'high-frequency-trading': 'Comprehensive 65-minute module with ecosystem analysis',
  'execution-algorithms': 'Expanded to 55 minutes with enhanced transaction cost analysis',
  'blockchain-technology': 'Complete bullet conversion with expanded fundamentals',
  'create-cryptocurrency': 'Added 1,200+ words on implementation considerations',
  'cryptocurrency-fundamentals': 'Added 1,500+ words on trading strategies',
  'defi-protocols': 'Added 2,200+ words on key concepts and opportunities',
  'digital-asset-trading': 'Added 2,500+ words on market dynamics',
  'julia-whitepaper': 'Added 1,000+ words on core principles',
  'market-risk-fundamentals': 'Enhanced VaR frameworks and governance',
  'liquidity-management': 'Converted 23 bullets with expanded working capital optimization',
  'factor-investing': 'Expanded factor model construction methodology',
  'stochastic-calculus': 'Converted 9 bullets with enhanced framework foundations',
  'commodity-risk-management': 'Expanded commodity price risk frameworks'
};

export function ModuleUpdateBanner({ moduleSlug }: ModuleUpdateBannerProps) {
  const isUpdated = UPDATED_MODULES.includes(moduleSlug);

  if (!isUpdated) {
    return null;
  }

  const description = UPDATE_DESCRIPTIONS[moduleSlug] || 'Recently enhanced with improved content';

  return (
    <div className="bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 border border-blue-200 dark:border-blue-800 py-3 px-4">
      <div className="max-w-4xl mx-auto mx-auto flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          <Sparkles className="w-5 h-5 text-blue-600 dark:text-blue-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-blue-900 dark:text-blue-200 mb-0.5">
            ✨ Recently Updated
          </p>
          <p className="text-sm text-blue-800 dark:text-blue-300">
            {description} • <a href="/WHATS_NEW.md" className="font-semibold hover:underline">View all updates</a>
          </p>
        </div>
      </div>
    </div>
  );
}
